import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionTo?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionTo,
  actionLabel = '返回首页',
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-24 px-4">
      <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-5">
        <i className={`${icon} text-3xl md:text-4xl`}></i>
      </span>
      <h3 className="text-lg md:text-xl font-bold text-foreground-900">{title}</h3>
      {description && <p className="text-sm text-foreground-500 mt-2 max-w-md">{description}</p>}
      <div className="flex items-center gap-3 mt-6">
        {actionTo && (
          <Link
            to={actionTo}
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {actionLabel}
          </Link>
        )}
        {onAction && (
          <button
            type="button"
            onClick={onAction}
            className="px-5 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            重置筛选
          </button>
        )}
      </div>
    </div>
  );
}